// CE-04g-UI-tick-fallback (v2) + MD-00 (v2-extended): derive the
// authoritative real-instant for a tick, or drop it.
//
// Precedence: tick.eventTs (IBKR event time, e.g. RTVolume tradeTimeMs)
// is preferred over tick.ts (bridge receipt time). An invalid eventTs
// SKIPS to ts without warning — only when BOTH are invalid does the
// function drop the tick (returns null) with exactly one console.warn.
//
// NO fallback to Date.now(). Browser receipt time misbuckets replayed
// cached ticks and delayed boundary ticks, so we never fabricate. Bad
// ticks are dropped at the call site (reduceLiveTick, the forming-bar
// trigger in useCandleStore) and surfaced via warn.
//
// Seconds-vs-ms autodetect: Math.abs(v) < 1e12 → seconds; otherwise ms.
// Both current producers (bridge-server.js, ibkrStream.js seed) emit
// milliseconds via Date.now(); the autodetect is preserved for any
// historical payload shape.

function resolveEpochToDate(v) {
  if (typeof v !== 'number' || !Number.isFinite(v) || v <= 0) return null
  const ms = Math.abs(v) < 1e12 ? v * 1000 : v
  const d = new Date(ms)
  return Number.isNaN(d.getTime()) ? null : d
}

export function getTickInstant(tick) {
  const fromEvent = resolveEpochToDate(tick?.eventTs)
  if (fromEvent) return fromEvent
  const fromReceipt = resolveEpochToDate(tick?.ts)
  if (fromReceipt) return fromReceipt
  console.warn('[getTickInstant] dropping tick — invalid or missing tick.eventTs/tick.ts', tick)
  return null
}
